import { render } from "./UploadElement.vue?vue&type=template&id=b841bb46"
import script from "./UploadElement.vue?vue&type=script&lang=js"
export * from "./UploadElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__